// @flow
// $FlowFixMe
import React, { useMemo } from "react";
import formatSequential from "@tvg/formatter/numeric";
import Icon from "@fdr/static-ui/Icons";
import { laurelLeft, laurelRight } from "@fdr/static-ui/Icons/icons";

import {
  RaceNumber,
  Number
} from "../../_molecules/PastPerformances/styled-components";
import RaceResultContainer from "./styled-components";

type Props = {
  result: number,
  numberOfRunners: number,
  isPodium: boolean,
  isEmpty: boolean
};

const RaceResult = (props: Props) => {
  const { result, numberOfRunners, isPodium, isEmpty } = props;

  const getRunnnerFinishedPosition = (
    finishedPosition: number
  ): number | string =>
    result !== 99 ? formatSequential(finishedPosition) : "DNF";

  const renderResult = () =>
    isEmpty ? (
      <RaceNumber isEmpty isResult>
        <Number isEmpty isPodium={isPodium} />
        <span />
      </RaceNumber>
    ) : (
      <RaceNumber isResult>
        <Number isPodium={isPodium}>
          {isPodium && <Icon icon={laurelLeft} size={14} />}
          <span>{result ? getRunnnerFinishedPosition(result) : "N/A"}</span>
          {isPodium && <Icon icon={laurelRight} size={14} />}
        </Number>
        {result !== 99 && <span>OF {numberOfRunners}</span>}
      </RaceNumber>
    );

  return useMemo(
    () => <RaceResultContainer>{renderResult()}</RaceResultContainer>,
    [numberOfRunners, isPodium, JSON.stringify(result)]
  );
};

RaceResult.defaultProps = {
  result: 0,
  numberOfRunners: 0,
  isPodium: false,
  isEmpty: false
};

export default RaceResult;
